import { MessageBox } from "element-ui";
const globalFunction = {}
globalFunction.SecondaryConfirm = (params) => {
    MessageBox.confirm(params.message || '确认删除当前数据吗？删除后将无法恢复', params.title || '提示', {
        confirmButtonText: params.confirm || 'Confirm',
        cancelButtonText: params.cancel || 'Cancel ',
        closeOnClickModal: false, //取消单击遮罩层关闭MessageBox
        closeOnPressEscape: false, //取消按下“Esc”键关闭MessageBox
        type: params.type || 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                const is_function = params.thenFun && Object.prototype.toString.call(params.thenFun) === '[object Function]';
                // 按钮加载状态
                instance.confirmButtonLoading = is_function;
                is_function && params.thenFun().then(() => {
                    instance.confirmButtonLoading = false;
                    done();
                })
            } else {
                done();
            }
        }
    }).then(() => { }).catch(() => { })
}

export default {
    install(app) {
        app.prototype['SecondaryConfirm'] = globalFunction.SecondaryConfirm;
    }
}


// WEBPACK FOOTER //
// ./src/utils/global.js